export default "__VITE_ASSET__BMShwEGl__"